export const muscleWikiData = {
  "project": {
    "name": "MuscleWiki - One Line Drawing Edition",
    "version": "1.0.0",
    "description": "Sistema completo de ejercicios y anatomia muscular en version un solo trazo explicativo",
    "style": "one-line-drawing",
    "stroke_color": "#1a1a2e",
    "active_muscle_color": "#e63946",
    "background_color": "#ffffff",
    "stroke_width": 2.5,
    "active_stroke_width": 4.5,
    "animation_duration": 2.5,
    "frames_per_gif": 5
  },
  "anatomy_maps": {
    "male_front": {
      "id": "map_male_front",
      "name": "Mapa Muscular Frontal - Hombre",
      "type": "interactive_map",
      "prompt": "Single continuous one-line drawing, male muscular anatomy front view, complete unbroken black stroke from head to toe, flowing lines showing: trapezius, deltoids, pectorals with internal fiber curves, rectus abdominis with 6-8 vertical waves, obliques with diagonal lines, biceps with front bulges, forearms, quadriceps with 4 parallel columns, knee spiral, tibialis anterior, foot. No pen lifting, elegant minimalist fitness illustration, white background, precise anatomical proportions",
      "muscles": [
        "trapezius",
        "deltoids",
        "pectorals",
        "abs",
        "obliques",
        "biceps",
        "forearms",
        "quadriceps",
        "tibialis",
        "adductors"
      ],
      "svg_path_complexity": "high",
      "interactive_zones": 15
    },
    "male_back": {
      "id": "map_male_back",
      "name": "Mapa Muscular Posterior - Hombre",
      "type": "interactive_map",
      "prompt": "Single continuous one-line drawing, male muscular anatomy back view, unbroken stroke from neck to heel: trapezius upper (wide rhombus), latissimus dorsi (triangles under armpits), spine (central line with spirals for vertebrae), glutes (2 semicircles), hamstrings (3 parallel back bands), calves (2 heads), heel. Symmetrical flowing lines, minimalist anatomy art, white background",
      "muscles": [
        "trapezius",
        "rhomboids",
        "lats",
        "erector_spinae",
        "glutes",
        "hamstrings",
        "calves",
        "rear_deltoids"
      ],
      "svg_path_complexity": "high",
      "interactive_zones": 14
    },
    "female_front": {
      "id": "map_female_front",
      "name": "Mapa Muscular Frontal - Mujer",
      "type": "interactive_map",
      "prompt": "Single continuous one-line drawing, female muscular anatomy front view, elegant flowing curves, softer hip lines, rounded glutes, defined waist, flowing thigh lines, unbroken stroke from head to toe showing all muscle groups with feminine proportions, minimalist fitness illustration, white background",
      "muscles": [
        "trapezius",
        "deltoids",
        "pectorals",
        "abs",
        "obliques",
        "biceps",
        "forearms",
        "quadriceps",
        "tibialis",
        "adductors"
      ],
      "svg_path_complexity": "high",
      "interactive_zones": 15
    },
    "female_back": {
      "id": "map_female_back",
      "name": "Mapa Muscular Posterior - Mujer",
      "type": "interactive_map",
      "prompt": "Single continuous one-line drawing, female muscular anatomy back view, elegant curves emphasizing lumbar curves, prominent glutes with wider loops, long hamstrings, defined calves, unbroken stroke from neck to heel, minimalist anatomy art, white background",
      "muscles": [
        "trapezius",
        "rhomboids",
        "lats",
        "erector_spinae",
        "glutes",
        "hamstrings",
        "calves",
        "rear_deltoids"
      ],
      "svg_path_complexity": "high",
      "interactive_zones": 14
    }
  },
  "muscle_groups": {
    "pectorals": {
      "id": "muscle_pectorals",
      "name": "Pectorales",
      "name_en": "Pectorals",
      "muscles": [
        "pectoralis_major",
        "pectoralis_minor"
      ],
      "diagram_prompt": "One-line drawing, pectoral muscle anatomy, single unbroken black line starting from sternum expanding into 2 large horizontal spirals (pectoralis major), with smaller internal loop for pectoralis minor diving toward clavicle, minimalist medical art, white background, precise muscle fiber flow",
      "location": "front_chest",
      "exercises_count": 42
    },
    "lats": {
      "id": "muscle_lats",
      "name": "Dorsales",
      "name_en": "Latissimus Dorsi",
      "diagram_prompt": "One-line drawing, latissimus dorsi muscle, inverted V line starting at lower spine widening into 2 large triangles rising toward arms, wing-like unfolding pattern, single unbroken stroke, minimalist anatomy illustration, white background",
      "location": "back_wings",
      "exercises_count": 38
    },
    "trapezius": {
      "id": "muscle_trapezius",
      "name": "Trapecio",
      "name_en": "Trapezius",
      "muscles": [
        "trapezius_upper",
        "trapezius_middle",
        "trapezius_lower"
      ],
      "diagram_prompt": "One-line drawing, trapezius muscle, diamond shape starting from neck widening into rhombus toward shoulders, internal lines for upper middle and lower fiber sections, single unbroken stroke, minimalist anatomy art, white background",
      "location": "upper_back_neck",
      "exercises_count": 25
    },
    "deltoids": {
      "id": "muscle_deltoids",
      "name": "Deltoides",
      "name_en": "Deltoids",
      "muscles": [
        "deltoid_anterior",
        "deltoid_lateral",
        "deltoid_posterior"
      ],
      "diagram_prompt": "One-line drawing, deltoid muscle, circular line surrounding shoulder with 3 internal petals: front curve (anterior), upper semicircle (lateral), rear curve (posterior), single unbroken stroke, minimalist anatomy illustration, white background",
      "location": "shoulders",
      "exercises_count": 35
    },
    "biceps": {
      "id": "muscle_biceps",
      "name": "Biceps",
      "name_en": "Biceps Brachii",
      "muscles": [
        "biceps_long_head",
        "biceps_short_head"
      ],
      "diagram_prompt": "One-line drawing, biceps brachii, line descending from shoulder splitting into 2 parallel teardrops (long and short head), central loop for muscle belly, ending in spiral at elbow, single unbroken stroke, minimalist anatomy art, white background",
      "location": "front_arms",
      "exercises_count": 28
    },
    "triceps": {
      "id": "muscle_triceps",
      "name": "Triceps",
      "name_en": "Triceps Brachii",
      "muscles": [
        "triceps_lateral",
        "triceps_long",
        "triceps_medial"
      ],
      "diagram_prompt": "One-line drawing, triceps brachii, line descending posterior arm creating 3 lobes (lateral, long, medial heads), horseshoe-shaped union line near elbow, single unbroken stroke, minimalist anatomy illustration, white background",
      "location": "back_arms",
      "exercises_count": 30
    },
    "abs": {
      "id": "muscle_abs",
      "name": "Abdominales",
      "name_en": "Abdominals",
      "muscles": [
        "rectus_abdominis",
        "obliques_external",
        "obliques_internal",
        "transverse_abdominis"
      ],
      "diagram_prompt": "One-line drawing, abdominal muscles, central vertical line with 6 horizontal wave steps (six-pack), diagonal crossing lines toward sides (obliques), deep horizontal loop for transverse abdominis, single unbroken stroke, minimalist fitness art, white background",
      "location": "core_front",
      "exercises_count": 45
    },
    "quadriceps": {
      "id": "muscle_quadriceps",
      "name": "Cuadriceps",
      "name_en": "Quadriceps",
      "muscles": [
        "rectus_femoris",
        "vastus_lateralis",
        "vastus_intermedius",
        "vastus_medialis"
      ],
      "diagram_prompt": "One-line drawing, quadriceps muscle, line descending from front thigh bone branching into 4 parallel columns (rectus femoris, vastus lateral, intermedius, medial), uniting in spiral at kneecap, single unbroken stroke, minimalist anatomy art, white background",
      "location": "front_thighs",
      "exercises_count": 40
    },
    "hamstrings": {
      "id": "muscle_hamstrings",
      "name": "Isquiotibiales",
      "name_en": "Hamstrings",
      "muscles": [
        "biceps_femoris",
        "semitendinosus",
        "semimembranosus"
      ],
      "diagram_prompt": "One-line drawing, hamstring muscles, posterior thigh line with 3 parallel cords (biceps femoris, semimembranosus, semitendinosus), converging in inverted Y near knee, single unbroken stroke, minimalist anatomy illustration, white background",
      "location": "back_thighs",
      "exercises_count": 32
    },
    "glutes": {
      "id": "muscle_glutes",
      "name": "Gluteos",
      "name_en": "Glutes",
      "muscles": [
        "gluteus_maximus",
        "gluteus_medius",
        "gluteus_minimus"
      ],
      "diagram_prompt": "One-line drawing, gluteal muscles, 2 large semicircles (gluteus maximus), with internal concentric loops for medius and minimus, waves expanding from sacrum, single unbroken stroke, minimalist anatomy art, white background",
      "location": "buttocks",
      "exercises_count": 28
    },
    "calves": {
      "id": "muscle_calves",
      "name": "Pantorrillas",
      "name_en": "Calves",
      "muscles": [
        "gastrocnemius_lateral",
        "gastrocnemius_medial",
        "soleus"
      ],
      "diagram_prompt": "One-line drawing, calf muscles, 2 elongated hearts (medial and lateral gastrocnemius heads), with deep line for soleus diving toward Achilles tendon, single unbroken stroke, minimalist anatomy illustration, white background",
      "location": "lower_legs",
      "exercises_count": 22
    },
    "rhomboids": {
      "id": "muscle_rhomboids",
      "name": "Romboides",
      "name_en": "Rhomboids",
      "muscles": [
        "rhomboid_major",
        "rhomboid_minor",
        "teres_major",
        "teres_minor"
      ],
      "diagram_prompt": "One-line drawing, rhomboid and teres muscles, diamond shape between shoulder blades, internal loops for rhomboid major and minor, 2 lateral semicircles for teres muscles, single unbroken stroke, minimalist anatomy art, white background",
      "location": "upper_back_inner",
      "exercises_count": 18
    },
    "erector_spinae": {
      "id": "muscle_erectors",
      "name": "Erectores Espinales",
      "name_en": "Erector Spinae",
      "muscles": [
        "iliocostalis",
        "longissimus",
        "spinalis"
      ],
      "diagram_prompt": "One-line drawing, erector spinae muscles, vertical line running entire spine with parallel sinusoidal waves on both sides, vertebral column made of continuous wavy lines, single unbroken stroke, minimalist anatomy illustration, white background",
      "location": "spine",
      "exercises_count": 20
    },
    "forearms": {
      "id": "muscle_forearms",
      "name": "Antebrazo",
      "name_en": "Forearms",
      "muscles": [
        "brachioradialis",
        "flexor_group",
        "extensor_group",
        "pronator_teres"
      ],
      "diagram_prompt": "One-line drawing, forearm muscles, spiral line descending from elbow creating muscle braids winding toward wrist, loops for deep muscles, single unbroken stroke, minimalist anatomy art, white background",
      "location": "lower_arms",
      "exercises_count": 15
    }
  },
  "exercises": {
    "bodyweight": {
      "category": "Peso Corporal",
      "category_en": "Bodyweight",
      "exercises": [
        { "id": "ex_pushup", "name": "Flexiones", "name_en": "Push-up", "target_muscles": ["pectorals", "triceps", "deltoids", "abs"], "difficulty": "beginner" },
        { "id": "ex_squat", "name": "Sentadillas", "name_en": "Squat", "target_muscles": ["quadriceps", "glutes", "hamstrings", "calves"], "difficulty": "beginner" },
        { "id": "ex_plank", "name": "Plancha", "name_en": "Plank", "target_muscles": ["abs", "erector_spinae", "deltoids", "glutes"], "difficulty": "beginner" },
        { "id": "ex_pullup", "name": "Dominadas", "name_en": "Pull-up", "target_muscles": ["lats", "biceps", "rhomboids", "abs"], "difficulty": "intermediate" },
        { "id": "ex_dip", "name": "Fondos", "name_en": "Dip", "target_muscles": ["triceps", "pectorals", "deltoids"], "difficulty": "intermediate" },
        { "id": "ex_burpee", "name": "Burpees", "name_en": "Burpee", "target_muscles": ["full_body", "pectorals", "quadriceps", "abs", "deltoids"], "difficulty": "intermediate" },
        { "id": "ex_mountain_climber", "name": "Escaladores", "name_en": "Mountain Climber", "target_muscles": ["abs", "deltoids", "quadriceps", "calves"], "difficulty": "beginner" },
        { "id": "ex_wall_sit", "name": "Sentadilla de Pared", "name_en": "Wall Sit", "target_muscles": ["quadriceps", "glutes", "calves"], "difficulty": "beginner" },
        { "id": "ex_lunge", "name": "Zancadas", "name_en": "Lunge", "target_muscles": ["quadriceps", "glutes", "hamstrings", "calves"], "difficulty": "beginner" },
        { "id": "ex_leg_raise", "name": "Elevacion de Piernas", "name_en": "Leg Raise", "target_muscles": ["abs", "hip_flexors"], "difficulty": "beginner" },
        { "id": "ex_crunch", "name": "Abdominales", "name_en": "Crunch", "target_muscles": ["abs", "obliques"], "difficulty": "beginner" },
        { "id": "ex_russian_twist", "name": "Giro Ruso", "name_en": "Russian Twist", "target_muscles": ["abs", "obliques", "erector_spinae"], "difficulty": "beginner" },
        { "id": "ex_bicycle_crunch", "name": "Bicicleta Abdominal", "name_en": "Bicycle Crunch", "target_muscles": ["abs", "obliques", "hip_flexors"], "difficulty": "intermediate" },
        { "id": "ex_hanging_leg_raise", "name": "Elevacion de Piernas Colgado", "name_en": "Hanging Leg Raise", "target_muscles": ["abs", "hip_flexors", "lats"], "difficulty": "advanced" },
        { "id": "ex_ab_wheel", "name": "Rueda Abdominal", "name_en": "Ab Wheel Rollout", "target_muscles": ["abs", "erector_spinae", "deltoids", "lats"], "difficulty": "advanced" },
        { "id": "ex_superman", "name": "Superman", "name_en": "Superman", "target_muscles": ["erector_spinae", "glutes", "hamstrings", "deltoids"], "difficulty": "beginner" },
        { "id": "ex_bridge", "name": "Puente de Gluteos", "name_en": "Glute Bridge", "target_muscles": ["glutes", "hamstrings", "abs"], "difficulty": "beginner" },
        { "id": "ex_calf_raise_bodyweight", "name": "Elevacion de Talones", "name_en": "Bodyweight Calf Raise", "target_muscles": ["calves"], "difficulty": "beginner" },
        { "id": "ex_inverted_row", "name": "Remo Invertido", "name_en": "Inverted Row", "target_muscles": ["lats", "rhomboids", "biceps", "abs"], "difficulty": "intermediate" },
        { "id": "ex_pike_pushup", "name": "Flexion en Pike", "name_en": "Pike Push-up", "target_muscles": ["deltoids", "triceps", "abs", "pectorals"], "difficulty": "intermediate" }
      ]
    },
    "dumbbells": {
      "category": "Mancuernas",
      "category_en": "Dumbbells",
      "exercises": [
        { "id": "ex_db_press", "name": "Press con Mancuernas", "name_en": "Dumbbell Press", "target_muscles": ["pectorals", "triceps", "deltoids"], "difficulty": "beginner" },
        { "id": "ex_db_flyes", "name": "Aperturas con Mancuernas", "name_en": "Dumbbell Flyes", "target_muscles": ["pectorals", "deltoids"], "difficulty": "intermediate" },
        { "id": "ex_db_curl", "name": "Curl con Mancuernas", "name_en": "Dumbbell Curl", "target_muscles": ["biceps", "forearms"], "difficulty": "beginner" },
        { "id": "ex_db_row", "name": "Remo con Mancuerna", "name_en": "Dumbbell Row", "target_muscles": ["lats", "rhomboids", "biceps", "deltoids"], "difficulty": "beginner" },
        { "id": "ex_db_shoulder_press", "name": "Press de Hombros con Mancuernas", "name_en": "Dumbbell Shoulder Press", "target_muscles": ["deltoids", "triceps", "abs"], "difficulty": "beginner" },
        { "id": "ex_db_lateral_raise", "name": "Elevaciones Laterales", "name_en": "Dumbbell Lateral Raise", "target_muscles": ["deltoids", "trapezius"], "difficulty": "beginner" },
        { "id": "ex_db_rdl", "name": "Peso Muerto Rumano con Mancuernas", "name_en": "Dumbbell Romanian Deadlift", "target_muscles": ["hamstrings", "glutes", "erector_spinae", "trapezius"], "difficulty": "intermediate" }
      ]
    },
    "barbell": {
      "category": "Barra",
      "category_en": "Barbell",
      "exercises": [
        { "id": "ex_bb_bench_press", "name": "Press de Banca", "name_en": "Bench Press", "target_muscles": ["pectorals", "triceps", "deltoids"], "difficulty": "beginner" },
        { "id": "ex_bb_squat", "name": "Sentadilla con Barra", "name_en": "Barbell Squat", "target_muscles": ["quadriceps", "glutes", "hamstrings", "calves", "erector_spinae"], "difficulty": "intermediate" },
        { "id": "ex_bb_deadlift", "name": "Peso Muerto", "name_en": "Barbell Deadlift", "target_muscles": ["hamstrings", "glutes", "erector_spinae", "trapezius", "forearms", "quadriceps"], "difficulty": "intermediate" }
      ]
    }
  },
  "metadata": {
    "total_muscle_groups": 14,
    "total_anatomy_maps": 4,
    "total_exercise_categories": 3,
    "total_exercises": 115,
    "version": "1.0.0"
  }
};
